<template lang="pug">
  #menuComponent(ref="menu_component")
    ShipmentSelector(v-if="shipmentSelecting === true")
    .modal-warning-overlay(v-if="showShipmentWarning === true")
      .modal-warning
        h3.modal-confirm__title Địa chỉ nằm ngoài phạm vi giao hàng. Quý khách vui lòng chọn lại địa chỉ trong phạm vi 12km
        p.modal-confirm__content Mong bạn thông cảm với sự bất tiện này
        div.modal-confirm__actions
          a.modal-confirm__ok(@click.prevent="showShipmentWarning = false") Đồng ý

    .menuComponent-inner(v-if="shipmentSelecting === false")
      .wz-row
        .left-sidebar.sidebar
          .sidebar-inner
            ul.menus.nav
              li.menu-item(v-for='(menu,key) in menus' v-if='products[menu.text_id]' v-scroll-to="{el: '#menu-'+key, offset: -80,}")
                a(:href="'#menu-'+key" v-bind:class='{active: key === 1}') {{menu.name }}
        .main-sidebar.sidebar
          .sidebar-inner
            //pre(v-if="selectedRestaurant") {{ selectedRestaurant }}
            .search-area
              img(src='../assets/images/search.png' alt='')
              input(type='text' placeholder='Tìm kiếm món ăn...' autocomplete='off' v-on:input="$emit('updatesearch', $event.target.value)")
            .products-area
              template(v-if="true")
                .groupProducts(v-for='(menu,key) in menus' v-bind:id="'menu-'+key" v-if='products[menu.text_id] && filterproduct(products[menu.text_id]).length > 0')
                  .menuName
                    h3 {{menu.name}}
                  .productItems(v-if="menu.text_id != 'list_normal_combo' && menu.text_id != 'list_special_combo'")
                    .productItem(v-for='product in filterproduct(products[menu.text_id])' v-on:click='openModalProduct(product,-1,false)')
                      .productItem-inner
                        .productImage(v-if='product.image_url')
                          img(:src='product.image_url || imageDefault'
                            alt='…'
                            loading='lazy'
                            height='80'
                            @onerror='product.image_url = imageDefault')
                        .productInfo
                          h3.productName(v-html='product.name')
                          .productDesc(v-html='product.description' v-if='product.description')
                          p.productPrice {{product.ta_price | formatPrice}}
                          span.productButton
                  .productItems(v-else='')
                    .productItem(v-for='product in filterproduct(products[menu.text_id])' v-if='product.combo_details.length' v-on:click='openModalProduct(product,-1,false)')
                      .productItem-inner
                        .productImage
                          img(:src='imageDefault' alt='')
                        .productInfo
                          h3.productName(v-html='product.combo_name || product.combo_id')
                          p.productPrice {{product.ta_price | formatPrice}}
                          span.productButton
        .right-sidebar.sidebar(ref="mobile-cart")
          .sidebar-inner
            span.hide-cart(@click.prevent="hideCart" v-if="showMobileCart && (isMobile || isTablet)")
              svg(width='24' height='24' viewbox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg')
                path(d='M20.7071 7.29288C21.0676 7.65337 21.0953 8.2206 20.7903 8.61289L20.7071 8.7071L12.7071 16.7071C12.3466 17.0676 11.7794 17.0953 11.3871 16.7903L11.2929 16.7071L3.2929 8.7071C2.9024 8.31657 2.9024 7.68341 3.2929 7.29288C3.6534 6.9324 4.2206 6.90467 4.6129 7.20969L4.7071 7.29288L12 14.5858L19.2929 7.29288C19.6834 6.90236 20.3166 6.90236 20.7071 7.29288Z' fill='#ADA8A8')

            .cartItems
              h3 Thông tin giỏ hàng
              perfect-scrollbar
                template(v-if='cart.ordersItem.length')
                  .item(v-for='(item,index) in cart.ordersItem')
                    .name(v-on:click='openModalProduct(item.product,index,item.order)')
                      .itemInfo
                        p.itemName {{item.order.Item_Name}}
                        .options(v-if='!item.order.isCombo')
                          .opItem(v-for='(op,key) in item.order.options')
                            template
                              span.opName {{op.name}}
                              span.opVal(v-for='val in op.options') {{val}}
                              .opDetailsList(v-if='op.model')
                                p.opDetails(v-for='s in op.model' v-if='s.quantity > 0')
                                  | {{ s.name }} x {{ s.quantity }}
                        .options(v-else='')
                          .opItem(v-for='(op,key) in item.order.options')
                            span.opVal(v-for='val in op.details' v-if='op.selected === val.Item_Id') {{val.Item_Name}}
                    .item-foot
                      .item-quantity
                        cart-quantity(v-model='item.order.Quantity' @input="updateItemCart(index, item)")
                      .price
                        | {{((item.order.Price + item.order.plusPrice) * item.order.Quantity ) | formatPrice}}
                    span.deleteItem(v-on:click='deleteCartItem(index)')
                      svg(width='14' height='14' viewbox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg')
                        path(d='M6.99967 0.166672C8.15501 0.166672 9.09914 1.07097 9.16294 2.21039L9.16634 2.33334H12.6663C12.9425 2.33334 13.1663 2.5572 13.1663 2.83334C13.1663 3.08647 12.9782 3.29567 12.7342 3.32877L12.6663 3.33334H12.1357L11.2823 12.0128C11.1938 12.9122 10.4653 13.6067 9.57474 13.663L9.45774 13.6667H4.54163C3.6379 13.6667 2.87544 13.0097 2.73223 12.1289L2.7171 12.0128L1.86301 3.33334H1.33301C1.07987 3.33334 0.870681 3.14524 0.837574 2.90119L0.833008 2.83334C0.833008 2.58021 1.02111 2.37101 1.26516 2.3379L1.33301 2.33334H4.83301C4.83301 1.13672 5.80307 0.166672 6.99967 0.166672ZM11.131 3.33334H2.86767L3.71229 11.9149C3.75146 12.3131 4.06656 12.6229 4.45691 12.6624L4.54163 12.6667H9.45774C9.85781 12.6667 10.1969 12.3834 10.2745 11.9988L10.2871 11.9149L11.131 3.33334ZM8.16634 5.16667C8.41947 5.16667 8.62867 5.35477 8.66181 5.59882L8.66634 5.66667V10.3333C8.66634 10.6095 8.44247 10.8333 8.16634 10.8333C7.91321 10.8333 7.70401 10.6452 7.67087 10.4012L7.66634 10.3333V5.66667C7.66634 5.39053 7.89021 5.16667 8.16634 5.16667ZM5.83301 5.16667C6.08614 5.16667 6.29534 5.35477 6.32847 5.59882L6.33301 5.66667V10.3333C6.33301 10.6095 6.10914 10.8333 5.83301 10.8333C5.57987 10.8333 5.37068 10.6452 5.33757 10.4012L5.33301 10.3333V5.66667C5.33301 5.39053 5.55687 5.16667 5.83301 5.16667ZM6.99967 1.16667C6.38754 1.16667 5.88554 1.63808 5.83687 2.23765L5.83301 2.33334H8.16634C8.16634 1.68901 7.64401 1.16667 6.99967 1.16667Z' fill='#ADA8A8')
                p.not-found(v-else) Bạn chưa chọn món nào!
            .cartItemsTotal
              p Tổng {{cart | countTotalItems}} món
              p.orderAmount {{cart | totalPrice}}
            .totalPrice
              .totalText
                p Thông báo
                p.orderTotal {{cart | totalPrice}}
              .viewCartBtn
                button(v-bind:class="{'disable': cart.ordersItem.length < 1}" v-on:click.prevent='gotoCheckout') Đặt hàng
      .mobile_cart
        button(type='button' v-on:click='showCart()')
          .content_button
            .col
              svg(width='24' height='24' viewbox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg')
                path(d='M24 9.80364V10.4822C24 11.0444 23.5523 11.5001 23 11.5001H22.6667L21.5786 19.2522C21.4379 20.2551 20.594 21 19.5988 21H4.40125C3.40596 21 2.56212 20.2551 2.42133 19.2522L1.33333 11.5001H1C0.447708 11.5001 0 11.0444 0 10.4822V9.80364C0 9.24149 0.447708 8.78579 1 8.78579H3.80588L8.25504 2.55905C8.68817 1.95292 9.522 1.81886 10.1176 2.25971C10.7131 2.70057 10.8448 3.54933 10.4117 4.1555L7.10321 8.78579H16.8968L13.5883 4.15546C13.1552 3.54933 13.2869 2.70053 13.8825 2.25967C14.4779 1.81882 15.3119 1.95283 15.745 2.55901L20.1941 8.78579H23C23.5523 8.78579 24 9.24149 24 9.80364ZM13 17.2679V12.5179C13 11.9558 12.5523 11.5001 12 11.5001C11.4477 11.5001 11 11.9558 11 12.5179V17.2679C11 17.83 11.4477 18.2857 12 18.2857C12.5523 18.2857 13 17.83 13 17.2679ZM17.6667 17.2679V12.5179C17.6667 11.9558 17.219 11.5001 16.6667 11.5001C16.1144 11.5001 15.6667 11.9558 15.6667 12.5179V17.2679C15.6667 17.83 16.1144 18.2857 16.6667 18.2857C17.219 18.2857 17.6667 17.83 17.6667 17.2679ZM8.33333 17.2679V12.5179C8.33333 11.9558 7.88563 11.5001 7.33333 11.5001C6.78104 11.5001 6.33333 11.9558 6.33333 12.5179V17.2679C6.33333 17.83 6.78104 18.2857 7.33333 18.2857C7.88563 18.2857 8.33333 17.83 8.33333 17.2679Z' fill='white')

              | Giỏ hàng {{cart | countTotalItems}} món
            .col
              span.amount {{cart | totalPrice}}
      // modal
      modal.modal-confirm(v-if='showTimeModal' @close='showTimeModal = true')
        h2(slot='header') Thông báo
        template(slot='body')
          p.alert.alert-danger
            | Hiện tại đã ngoài thời gian phục vụ của Sườn Mười.
            br
            | Thời gian phục vụ của Sườn Mười từ {{ openTime }} hàng ngày.
            br
            | Xin Quý khách vui lòng quay lại sau.
        template(slot='footer')
          .action
            button.btn.btn-remove(type='button' v-on:click='showTimeModal = false') Đóng
    modal-product(v-if="modalProduct.active" :order="modalProduct.orderItem" :product="modalProduct.product" @close="closeModalProduct()" :activeId="modalProduct.activeId" @updateCart="updateCart")
      span.closeModal(v-on:click='closeModalProduct()')
        svg(width='48' height='48' viewbox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg')
          path(d='M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z' fill='#3C3838')
          path(d='M16.2097 16.3871L16.2929 16.2929C16.6534 15.9324 17.2206 15.9047 17.6129 16.2097L17.7071 16.2929L24 22.585L30.2929 16.2929C30.6834 15.9024 31.3166 15.9024 31.7071 16.2929C32.0976 16.6834 32.0976 17.3166 31.7071 17.7071L25.415 24L31.7071 30.2929C32.0676 30.6534 32.0953 31.2206 31.7903 31.6129L31.7071 31.7071C31.3466 32.0676 30.7794 32.0953 30.3871 31.7903L30.2929 31.7071L24 25.415L17.7071 31.7071C17.3166 32.0976 16.6834 32.0976 16.2929 31.7071C15.9024 31.3166 15.9024 30.6834 16.2929 30.2929L22.585 24L16.2929 17.7071C15.9324 17.3466 15.9047 16.7794 16.2097 16.3871L16.2929 16.2929L16.2097 16.3871Z' fill='white')

    // modal


</template>

<script>
  import {mapState,mapGetters} from 'vuex'
  import { bus } from '../main'

  import CartQuantity from "./CartQuantity";
  import _ from 'lodash'
  import Modal from './Modal.vue';
  import ShipmentSelector from "./ShipmentSelector";

  const moment = require('moment-timezone');

  export default {
    name: 'Menu',
    components: {
      ShipmentSelector,
      CartQuantity,
      Modal,

    },
    props: ['search'],
    computed: {
      ...mapState({
        restaurants: state => state.restaurants.all,
        selectedRestaurant: state => state.restaurants.selected,
        shipments: state => state.shipments.all,
        selectedShipment: state => state.shipments.selected,
        shipmentSelecting: state => state.shipments.selecting,
      }),
      ...mapGetters({
        'menus': 'restaurants/currentMenu',
        'products': 'restaurants/currentProducts',
        'timeDelivery': 'restaurants/timeDelivery',
        'currentRestaurant': 'restaurants/currentRestaurantPos',
        'currentShipmentType': 'shipments/currentShipmentType',
        'currentLocation': 'shipments/currentLocation',
      }),
    },
    data() {
      return {
        //Order
        cart: this.$cart,
        //Products
        //products: [],
        v1_products: [],
        //Menus
        // menus: [],
        //Thong tin modal product
        modalProduct: {
          active: false,
          activeId: 0,
          product: null,
          orderItem: null
        },
        //modal
        modalBooking: false,
        showTimeModal: false,
        showMobileCart: false,
        openTime: null,
        //timeDelivery: null,
        imageDefault: this.$foodbookConfig.imageDefault,
        isMobile: false,
        isTablet: false,
        showShipmentWarning: false,
      };
    },
    beforeDestroy () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, { passive: true })
      }
    },
    mounted () {
      this.onResize()
      window.addEventListener('resize', this.onResize, { passive: true })
    },
    created() {

      console.log(this.selectedShipment,this.shipmentSelecting)

      this.checkCartExpire();
      this.checkTimeOpenning();

      bus.$on('removeCart', (data) => {
        this.$set(this.cart,'ordersItem' , [])
      });

      bus.$on('updateCart', (data) => {
        //this.$set(this.cart,'ordersItem' , [])
      });

      bus.$on('openShipmentSelector', (data) => {
        this.$store.dispatch('shipments/setSelecting', true)
        this.$store.dispatch('shipments/resetState', true)
        this.shipmentSelecting = true
      });
      bus.$on('shipmentWarning', (data) => {
        this.showShipmentWarning = true
      });




      //this.getProducts(this.selectedRestaurant);
      window.addEventListener('scroll', this.handleScroll);

      this.$store.dispatch('restaurants/getAllRestaurants')
      this.$store.dispatch('shipments/getAllShipments')

      // check shipment
      // nếu có tham biến `t` = `pickup` hoặc `delivery` thì xử lý
      const urlParams = new URLSearchParams(window.location.search);
      let type = urlParams.get('t');

      if ('pickup' === type || 'delivery' === type) {
        this.shipmentSelecting = true
        this.$store.dispatch('shipments/setSelecting', true)

      }
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    filters: {
      //Loc san pham duoc active
      filterProductsActive: (products, menus) => {
        return products.filter(product => {
          let productActive = true;
          let menu = _.find(menus, {'text_id': product.type_id, 'active': 1});
          if (product.status.toUpperCase() === 'DEACTIVE') {
            productActive = false;
          }
          if (typeof menu === 'undefined') {
            productActive = false;
          }
          return productActive;
        })
      },
      filterMenusActive: (menus) => {
        return menus.filter(item_type => {
          return (item_type.active === 1)
        })
      },
      //Nhom cac san pham cung category
      groupMenu: function (value) {
        if (!value) return [];
        let result = _.chain(value)
          .groupBy("type_id")
          .value();
        //console.log(result);
        return result;
      },

      //Nhom cac san pham cung category
      filterComboActive: (combos, products) => {
        if (!combos) return [];
        return combos.filter((combo, index, arr) => {

          let start_date = moment(combo.start_date).tz("Asia/Ho_Chi_Minh").valueOf();
          let start_time = combo.start_hour;
          let end_date = moment(combo.end_date).tz("Asia/Ho_Chi_Minh").valueOf();
          let end_time = combo.end_hour;
          let now_date = moment().tz("Asia/Ho_Chi_Minh").valueOf();
          let now_time = moment().tz("Asia/Ho_Chi_Minh").format('HH');

          if (combo.start_date) {
            if (now_date < start_date) return false;
          }
          if (combo.end_date) {
            if (now_date > end_date) return false;
          }
          if (combo.start_hour) {
            if (now_time < start_time) return false;
          }
          if (combo.end_hour) {
            if (now_time > end_time) return false;
          }

          if (!Array.isArray(combo.combo_details) || !combo.combo_details.length || !combo.active) return false;
          combos[index].ta_price = 0;
          combos[index].combo_details = this._.sortBy(combos[index].combo_details, ['order']);
          //Lay chi tiet san pham cho combo (store_item_id)
          for (let i = 0; i < combo.combo_details.length; i++) {
            let listId = combo.combo_details[i].item_id_list || combo.combo_details[i].item_id;
            if (!listId) return false;
            let listIdArray = listId.split(",");
            let listDetail = _.filter(products, product => {
              let isDetail = listIdArray.indexOf(product.Item_Id) >= 0;
              /*if(isDetail && product.Item_Image_Path && !combos[index].image_url){
                  combos[index].image_url = product.Item_Image_Path;
              }*/
              return isDetail;
            });
            combos[index].combo_details[i].details = listDetail;
            combos[index].combo_details[i].selected = listIdArray[0];
            combos[index].ta_price = combos[index].ta_price + combo.combo_details[i].ta_price;
          }
          if (!combos[index].ta_price) return false;
          return true;
        })
      },
      //Lay Ten cua menu theo key
      getMenuName(value, menus) {
        let menu = _.find(menus, {text_id: value});
        if (menu) {
          return menu.name;
        }
        return value;
      }
    },
    methods: {
      onResize () {
        this.isMobile = window.innerWidth < 591
        this.isTablet = window.innerWidth < 1199
      },
      getMinutes(str) {
        let time = str.split(':');
        return time[0] * 60 + time[1] * 1;
      },
      getMinutesNow() {
        let timeNow = new Date();
        return timeNow.getHours() * 60 + timeNow.getMinutes();
      },
      checkTimeOpenning() {
        let n = new Date().getDay() + 1;
        if (this.timeDelivery) {
          let day = _.find(this.timeDelivery, ["Day_Of_Week", n])
          if (day && Object.keys(day).length) {
            let now = this.getMinutesNow();
            //now = this.getMinutes("22:40");
            console.log(new Date())
            let start = this.getMinutes(day.Time_Start);
            let end = this.getMinutes(day.Time_End);
            if (start > end) end += this.getMinutes('24:00');

            this.openTime = day.Time_Start + ' - ' + day.Time_End;

            if ((now >= start) && (now <= end)) {
              // your code here
              console.log("Cửa hàng mở cửa!")
              this.showTimeModal = 0;
            } else {
              console.log("Cửa hàng đóng cửa!")
              this.showTimeModal = 1;
            }
          }
        }

      },
      checkCartExpire() {
        return false;
      },

      //Lấy toàn bộ sản phẩm có trong POS
      getProducts($pos_id = 0) {
        //this.loading = true;
        //this.$http.get(this.$foodbookConfig.api + 'xpartner/v2/items', {
        this.$http.get(this.$foodbookConfig.wpapi + '/products', {
          params: {
            pos_id: $pos_id,
            //pos_parent: this.$foodbookConfig.pos_name,
          }
        }).then(response => {
          if (!response) {
            this.$toasted.show("Hệ thống chưa được xử lý. Vui lòng thử lại sau..", {
              position: "top-center",
              duration: 5000,
              type: 'error'
            });
          } else {
            if (!response.body.error) {
              let menu = _.sortBy(response.body.data.item_types, ['sort', 'name']);
              this.menus = this.$options.filters.filterMenusActive(menu);

              this.timeDelivery = response.body.data.time_delivery || null;
              this.checkTimeOpenning();

              let datas = this.$options.filters.filterProductsActive(response.body.data.items, this.menus);
              //console.log(datas);
              this.products = this.$options.filters.groupMenu(datas);

              //Add combo code 210620219
              //Check nomal combo
              if (response.body.data.list_normal_combo && Array.isArray(response.body.data.list_normal_combo)) {
                //Check active combo
                let combo = this.$options.filters.filterComboActive(response.body.data.list_normal_combo, response.body.data.list_item_v1);
                //console.log(combo);
                if (combo.length) {
                  this.products.list_normal_combo = combo;
                  this.menus.push({
                    "active": 1,
                    "name": "COMBO THƯỜNG",
                    "text_id": "list_normal_combo",
                  });
                }
              }

              //Check special combo
              if (response.body.data.list_special_combo && Array.isArray(response.body.data.list_special_combo)) {
                let combo = this.$options.filters.filterComboActive(response.body.data.list_special_combo, response.body.data.list_item_v1);
                if (combo.length) {
                  this.products.list_special_combo = combo;
                  this.menus.push({
                    "active": 1,
                    "name": "COMBO ĐẶC BIỆT",
                    "text_id": "list_special_combo",
                  });
                }
              }

              //End add combo

              localStorage.shopTime = JSON.stringify(response.body.data.time_delivery);
            } else {
              this.$toasted.show(response.body.error.message, {
                theme: "bubble",
                position: "top-center",
                duration: 5000,
                type: 'error'
              });
            }
          }
        }, response => {
          //this.loading = false;
          //this.firstLoading = false;
        });
      },

      //Search Menu
      filterproduct(products) {
        return products.filter(product => {
          let search = false;
          if (product.combo_name) {
            search = this.clearText(product.combo_name).includes(this.clearText(this.search));
          }
          if (product.combo_id) {
            search = this.clearText(product.combo_id).includes(this.clearText(this.search));
          }
          if (product.name) {
            search = this.clearText(product.name).includes(this.clearText(this.search))
          }
          return search;

        })
      },
      closeModalProduct() {

        this.modalProduct.active = false
        this.toggleBodyClass('removeClass', 'no-scrollbar')
      },
      //Mo modal product
      openModalProduct(p, index, orderItem) {
        this.modalProduct.product = p;
        this.modalProduct.activeId = index;
        this.modalProduct.orderItem = orderItem;
        this.modalProduct.active = true;
        this.toggleBodyClass('addClass', 'no-scrollbar')
      },

      //Clear Text ve khong dau
      clearText(str) {
        str = str.toLowerCase();
        str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
        str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
        str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
        str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
        str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
        str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
        str = str.replace(/đ/g, "d");
        str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
        str = str.replace(/ + /g, " ");
        str = str.trim();
        return str;
      },

      //Update Cart
      updateCart(order, product, index) {
        if (index > -1) {
          //Chinh sua gio hang
          this.$set(this.cart.ordersItem, index, {'order': order, 'product': product});
        } else {
          this.cart.ordersItem.push({'order': order, 'product': product});
        }
        //Update session cart
        this.updateSessionCart();
        this.modalProduct.active = false;
        this.toggleBodyClass('removeClass', 'no-scrollbar')
      },
      updateItemCart(index, item) {
        this.updateSessionCart();
      },
      deleteCartItem(index) {
        this.cart.ordersItem.splice(index, 1);
        this.updateSessionCart();
      },
      updateSessionCart() {
        localStorage.cart = JSON.stringify(this.cart);
      },
      gotoCheckout() {
        if (!this.cart.ordersItem.length) {
          this.$toasted.show("Vui lòng chọn sản phẩm bạn muốn mua !", {
            position: "top-center",
            duration: 5000,
            type: 'error'
          });
        } else {
          localStorage.restaurant = JSON.stringify(this.currentRestaurant)
          localStorage.shipment = JSON.stringify(this.currentShipmentType)
          localStorage.location = JSON.stringify(this.currentLocation)
          window.location.replace('/thanh-toan/');
        }
      },
      handleScroll(event) {
        let scrollPosition = window.scrollY;
        let section = document.querySelectorAll(".groupProducts");
        var sections = {};
        _.forEach(section, function (value, key) {
          sections[value.id] = value.offsetTop - 40;
        });
        for (let i in sections) {
          if (sections[i] <= scrollPosition) {
            let elements;
            elements = document.querySelector('.menu-item .active')
            elements && elements.setAttribute('class', '');
            elements = document.querySelector('a[href*=' + i + ']')
            elements && elements.classList.add('active');
          }
        }
      },
      toggleBodyClass(addRemoveClass, className) {
        const el = document.body;

        if (addRemoveClass === 'addClass') {
          el.classList.add(className);
        } else {
          el.classList.remove(className);
        }
      },
      showCart() {
        this.showMobileCart = true
        this.$refs['mobile-cart'].classList.add('is-open')
        let root = document.getElementsByTagName( 'html' )[0]
        let body = document.getElementsByTagName( 'body' )[0]
        let header = document.getElementsByClassName( 'header-center' )[0]
        root.classList.add('no-scrollbar')
        body.classList.add('has-overlay')
        header.classList.add('no-zIndex')
      },
      hideCart() {
        this.showMobileCart = false
        this.$refs['mobile-cart'].classList.remove('is-open')
        let root = document.getElementsByTagName( 'html' )[0]
        let body = document.getElementsByTagName( 'body' )[0]
        let header = document.getElementsByClassName( 'header-center' )[0]
        root.classList.remove('no-scrollbar')
        body.classList.remove('has-overlay')
        header.classList.remove('no-zIndex')

      },
      estimateShipFee() {
        console.log('load');
      },
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/Menu.vue